import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { Answer } from './api';
import { useAnswersBySectionContext } from 'shared/providers/AnswersBySectionProvider';
import TrueImpactLoading from 'shared/components/TrueImpactLoading';
import {
  FinalBudget,
  getFinalizedBudget,
  DIRECT_COST_QUESTION_ID,
  FINAL_BUDGET_QUESTION_ID,
  OVERHEAD_COST_QUESTION_ID,
  IN_KIND_DONATIONS_QUESTION_ID,
} from 'npo/pages/ReportBuilder/Components/Budget/utils';
import TrueImpactJSON from 'shared/design-system/components/TrueImpactJSON';
import TrueImpactText from 'shared/design-system/base/TrueImpactText';

const getFinalBudget = (
  questionId: number,
  finalBudget: FinalBudget | undefined,
) => {
  switch (questionId) {
    case DIRECT_COST_QUESTION_ID:
      return finalBudget?.directCost;
    case OVERHEAD_COST_QUESTION_ID:
      return finalBudget?.overheadCost;
    case IN_KIND_DONATIONS_QUESTION_ID:
      return finalBudget?.inKindDonations;

    default:
      return undefined;
  }
};

interface RenderBudgetAnswerProps {
  answer: Answer | { question: { dbId: number } };
  reportId: number;
  parseObject: object;
}

const StyledDiv = styled.div``;

const RenderBudgetAnswer: React.FC<RenderBudgetAnswerProps> = ({
  answer,
  reportId,
  parseObject,
}) => {
  const [finalBudget, setFinalBudget] = useState<FinalBudget | undefined>(
    undefined,
  );
  const {
    answers,
    handleSection,
    requestAnswerState,
  } = useAnswersBySectionContext();

  useEffect(() => {
    handleSection(reportId, 'finalize_report');
  }, []);

  useEffect(() => {
    if (requestAnswerState.type !== 'REQUEST_SUCCESS') {
      return;
    }
    setFinalBudget(
      getFinalizedBudget(
        answers[reportId]?.['finalize_report']?.[FINAL_BUDGET_QUESTION_ID]
          ?.text,
      ),
    );
  }, [requestAnswerState]);

  if (requestAnswerState.type === 'REQUEST_START') {
    return <TrueImpactLoading singleLine={true} />;
  }

  const final = getFinalBudget(answer.question.dbId, finalBudget);

  if (final) {
    return (
      <TrueImpactText variant="body-small">
        <strong className="answer-label">Answer:</strong> ${final}
      </TrueImpactText>
    );
  }

  return <TrueImpactJSON parseObject={parseObject} />;
};

export default RenderBudgetAnswer;
